/**
 *    @tableOfContent
 *      1. Dependencies
 *      2. Class
 *      3. Export class
 *
 */

/**
 *     @section 1. Dependencies
 */
import Helper from '../app/app--helper'
import MarkerIcon from './modules/marker-icon'
import Popup from './modules/popup'

// Download Geo data for regions
// https://download.geofabrik.de/europe.html
// Click on the country
// >> example URL: https://download.geofabrik.de/europe/poland/dolnoslaskie.html
// change 'html' to 'kml' in the url
// open kml in qgis (desktop app) > drag and drop the file
//  > right click on the layer > export > save as geojson
//  > save the file in the dist/map folder
//
// merge all layers in one layer:
// Use the 'Select layer' tool in the top bar (yellow with a white arrow)
// select the layer in the layers panel and add it to the selection, do this for all layers.
// Open Open the Processing Toolbox "Ctrl+Alt+T"
// Search for the "Merge vector layers" tool
// After this: Select the new Layer and Click in the top bar on the "Vector > Geoprocessing Tools > Dissolve" icon
// Save the new layer as geojson. Thats it.


/**
 *     @section 2. Class
 */
class MapOverview {
    constructor() {
        if (document.querySelector('.map--overview .map__vendor')) {
            document.addEventListener('map:loaded', () => {
                this.initMap()
            })
        }
    }

    initMap() {
        const mapJsonData = JSON.parse(document.querySelector('[data-map-json]')?.dataset.mapJson)
        const themePath = document.querySelector('[data-theme-path]')?.dataset.themePath

        let map: google.maps.Map
        async function initMap(): Promise<void> {
            //@ts-ignore
            const { Map } = await google.maps.importLibrary('maps')
            map = new Map(document.querySelector('.map--overview .map__vendor') as HTMLElement, {
                center: { lat: 52.52437, lng: 13.41053 },
                zoom: 4,// 8,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false
            })

            map.data.loadGeoJson(`${themePath}/dist/map/complete-region.geojson`)

            // Style the GeoJSON
            map.data.setStyle({
                fillColor: '#3871C1',
                fillOpacity: 0,
                strokeColor: '#3871C1',
                strokeWeight: 4,
                strokeOpacity: 0.5
            })

            // zoom in
            map.data.addListener('addfeature', function(event) {
                // Get the bounds of the feature (polygon)
                let bounds = new google.maps.LatLngBounds()
                event.feature.getGeometry().forEachLatLng((latlng) => {
                    bounds.extend(latlng)
                })

                // Zoom to the bounds
                map.fitBounds(bounds)
            })

            //
            // our data
            //

            let markers = [];
            let markerGroups = {
                wellness: [],
                medicine: [],
                rehabilitation: [],
                experience: [],
                // Add more groups if needed
            }

            const infowindow = new google.maps.InfoWindow()

            mapJsonData.forEach((item) => {
                // console.log(item)
                const type = item.type.replace('orh_partner_', '')
                const geolocation = item.geolocation.split(', ')
                const title = item.title
                const color = Helper.color[type]
                const image = item.image
                const region = item.region
                const nid = item.nid

                // console.log(link)
                const regex = /<a\s+(?:href="([^"]+)"\s+hreflang="([^"]+)"|hreflang="([^"]+)"\s+href="([^"]+)")[^>]*>/
                const match = region.match(regex)
                const href = match[1] || match[4]
                const hreflang = match[2] || match[3]

                // Create marker objects and add them to marker groups
                const marker = new google.maps.Marker({
                    position: { lat: parseFloat(geolocation[0]), lng: parseFloat(geolocation[1]) },
                    map: map,
                    title: title,
                    icon: MarkerIcon.get(color)
                })

                // add marker to group
                markers.push(marker)
                markerGroups[type].push(marker)

                // open popup
                marker.addListener('click', () => {
                    // info popup
                    infowindow.setContent(Popup.render({
                        image: image,
                        region: region,
                        type: type,
                        link: {
                            href: href,
                            hreflang: hreflang,
                            nid: nid
                        },
                        title: title
                    }))
                    infowindow.open(map, marker)
                })

                // Add event listener for mouseover
                marker.addListener('mouseover', () => {
                    marker.setOptions({zIndex:10})
                    // Scale the marker when hovered
                    marker.setIcon(MarkerIcon.get(color, 'large'))
                })

                marker.addListener('mouseout', () => {
                    marker.setOptions({zIndex:1})
                    // Scale the marker when hovered
                    marker.setIcon(MarkerIcon.get(color))
                })
            })

            //
            // filter bar toggle
            //
            document.querySelectorAll('.map-filter .field--tag .field__control')?.forEach((fieldEl) => {
                fieldEl?.addEventListener('change', () => {
                    const category = fieldEl.dataset.id
                    toggleMarkerGroup(category, fieldEl.checked)
                })
            })

            function toggleMarkerGroup(groupName, visible) {
                markerGroups[groupName].forEach(function(marker) {
                    marker.setVisible(visible)
                })
            }
        }

        initMap()
    }
}

/**
 *     @section 3. Export class
 */

export default new MapOverview()

// end of map-overview.ts file
